'use client'

import * as BaseSwitch from '@radix-ui/react-switch'
import { COLORS } from '@/utils/styles/colors'

interface SwitchProps {
    checked: boolean
    onToggle: () => void
    label?: string
}

export const Switch = ({ checked, onToggle, label }: SwitchProps) => {
    return (
        <div className="flex flex-row items-center gap-x-2">
            <BaseSwitch.Root
                onCheckedChange={onToggle}
                checked={checked}
                className="cursor-pointer select-none min-w-[52px] w-[52px] min-h-[28px] rounded-full border-none relative
                    -webkit-tap-highlight-color-transparent p-0 focus:outline-hidden"
                style={{ backgroundColor: checked ? '#D7F0E1' : '#E5E5E5' }}
            >
                <BaseSwitch.Thumb
                    className="absolute top-[3px] left-[3px] w-[22px] h-[22px] bg-white rounded-full transition-transform transform
                        will-change-transform"
                    style={{
                        transform: checked ? 'translateX(24px)' : 'translateX(0px)',
                        backgroundColor: checked ? COLORS.neotaste : '#AAAAAA',
                    }}
                />
            </BaseSwitch.Root>

            {label && <span>{label}</span>}
        </div>
    )
}
